import fp from 'lodash/fp';

export const userSelector = fp.compose(fp.get('users.data.data.user'));
export const userIdSelector = fp.compose(fp.get('users.id'));
export const userRoleSelector = fp.compose(fp.get('users.userRole'));
